export const TOKEN_KEY = "wow-delivery-kw-merchant-token";
export const CURRENT_BRANCH_KEY = "wow-delivery-kw-merchant-current-branch";
export const BRANCHES_KEY = "wow-delivery-kw-merchant-branches";

const SESSION_KEYS = [TOKEN_KEY, CURRENT_BRANCH_KEY, BRANCHES_KEY];

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const readJSON = (key) => {
    try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch (err) {
        localStorage.removeItem(key);
        return null;
    }
};

export const clearSession = () => {
    SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const clearBranchCache = () => {
    localStorage.removeItem(CURRENT_BRANCH_KEY);
    localStorage.removeItem(BRANCHES_KEY);
};